/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'components/minus': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _fill="#B2B2B2" fill-rule="evenodd" d="M12 9H4V7h8v2z" clip-rule="evenodd"/>'
  }
})
